
    let initResolve, initReject
    const initPromise = new Promise((re, rj) => {
      initResolve = re
      initReject = rj
    })
    module.exports = {
      initPromise,
      initResolve,
      initReject
    }
    